import { connect } from 'react-redux'
import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import './app.css'
import ContentPane from './ContentPane'
import { getUploads } from '../misc/selectors'
import Navbar from '../nav/Navbar'
import { processUploadedFiles } from '../misc/utilities'
import { browserHistory, Link } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { isMobile } from '../misc/selectors'
import ExceedsLimitsModal from '../misc/modals/ExceedsLimits'

const mapStateToProps = (state, ownProps) => ({
  viewParams: ownProps.viewParams,
  me: state.me,
  uploads: getUploads(state),
  isMobile: isMobile(state),
})

class App extends Component {
  constructor() {
    super()
  }

  componentWillReceiveProps(nextProps) {
    if (window.ga) {
      window.ga('set', 'metric1', this.props.me.embed_plays || 0);
      window.ga('set', 'metric2', this.props.me.total_plays || 0);
      window.ga('set', 'dimension2', this.props.me.user_name);
      window.ga('set', 'userId', this.props.me.user_name);
    }
  }

  render() {
    const { me, dispatch } = this.props
    if (me.dark_mode) {
      document.documentElement.className = "dark";
    } else {
      document.documentElement.className = "";
    }

    return (
      
      <Dropzone
        onDrop={(acceptedFiles, rejectedFiles) => {
          processUploadedFiles(this.props.dispatch, acceptedFiles, null, this.props.me.plan_max_length, this.props.me.plan_max_size)
        }}
        noClick
        disabled={this.props.viewParams.view === 'settings'}
      >
        {({getRootProps, getInputProps, isDragActive}) => (
        <div 
          className={`app-container`} 
          {...getRootProps()}
        > 
          {isDragActive ? <div className="drop-accepted"><div className="drop-accepted-text">Drop anywhere.</div></div> : ''}
          <input {...getInputProps()} />
          <ExceedsLimitsModal />
          {this.props.me.user_name ? '' :
          <div className="anon-bar">
            {this.props.isMobile
            ?  <span onClick={() => browserHistory.push("/signup?signup_src=anon-banner")}><FontAwesomeIcon icon={faUserSecret} /> You are anonymous. Sign up to save your videos.</span>
            :  <span><FontAwesomeIcon icon={faUserSecret} /> <span className='mobile-only'>You are anonymous.</span><span className='desktop-only'>You are uploading using an anonymous session. Sign up now to save your videos to an account.</span> <Link to="/signup?signup_src=anon-banner">Sign Up</Link> </span>
            }
          </div>
          }
          {this.props.me.subscription_status == 'UNPAID' ?
          <div className="delinquent-bar">
            <span>We had a problem billing your subscription. Please update your billing information now.</span> <span className='mobile-only'>Your account is past due.</span> {this.props.me.payment_processor ? (this.props.me.payment_processor == 'paypal' ? <a target="_blank" href="https://www.paypal.com/myaccount/">Go to PayPal</a> : <Link to="/change_payment">Update Card</Link>) : <Link to="/billing">Billing Info</Link>}  
          </div>
          : ''}
          <Navbar viewParams={this.props.viewParams} rootUrl={this.props.viewParams.query ? this.props.viewParams.query.rootUrl : null} key="navbar" />
          <div className="main-content">
            <ContentPane viewParams={this.props.viewParams} />
          </div>
          <div className="main-footer" data-nosnippet>
            <ul className="nav nav-pills nav-stacked nav-bottom">
              <li className="terms-footer">
                <a href="https://terms.streamable.com/">Terms</a>
                <a href="https://privacy.streamable.com/">Privacy</a>
                <a href="https://support.streamable.com/">Support</a>
                <a href="" onClick={(e) => {
                  e.preventDefault(); 
                  if (window.Beacon) {
                    window.Beacon('open') 
                  } else {
                    window.location = 'mailto:support@streamable.com'
                  }
                }} >Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
        )}
      </Dropzone>
    )
  }
}

export default connect(mapStateToProps)(App)
